import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useAuth } from './store/hooks/useAuth';
import Layout from './components/Layout';
import { LoginPage, DashboardPage, ServicesPage, BookingsPage, TransactionsPage, UsersPage, SalonsPage, SalonDetailPage, VendorsPage, AddUserPage, EditUserPage, AddVendorPage, CategoriesPage, PackagesPage, AddCategoryPage, WithdrawRequestPage, WithdrawRequestDetailPage, VendorBankAccountsPage, VendorBankAccountDetailPage } from './pages';

function SalonEditRedirect() {
  const { id } = useParams();
  return <Navigate to={id ? `/salons/${id}` : '/salons'} replace />;
}

function App() {
  const { isAuthenticated } = useAuth();
  const AuthenticatedLayout = ({ children }) => (
    isAuthenticated ? <Layout>{children}</Layout> : <Navigate to="/login" />
  );

  return (
    <Router>
        <Routes>
        <Route
          path="/login"
          element={!isAuthenticated ? <LoginPage /> : <Navigate to="/dashboard" />}
        />
        <Route
          path="/dashboard"
          element={<AuthenticatedLayout><DashboardPage /></AuthenticatedLayout>}
        />
        <Route
          path="/users"
          element={<AuthenticatedLayout><UsersPage /></AuthenticatedLayout>}
        />
        <Route
          path="/users/add"
          element={<AuthenticatedLayout><AddUserPage /></AuthenticatedLayout>}
        />
        <Route
          path="/users/:id/edit"
          element={<AuthenticatedLayout><EditUserPage /></AuthenticatedLayout>}
        />
        <Route
          path="/salons"
          element={<AuthenticatedLayout><SalonsPage /></AuthenticatedLayout>}
        />
        <Route
          path="/salons/add"
          element={<AuthenticatedLayout><Navigate to="/salons" replace /></AuthenticatedLayout>}
        />
        <Route
          path="/salons/:id/edit"
          element={<AuthenticatedLayout><SalonEditRedirect /></AuthenticatedLayout>}
        />
        <Route
          path="/salons/:id"
          element={<AuthenticatedLayout><SalonDetailPage /></AuthenticatedLayout>}
        />
        <Route
          path="/vendors"
          element={<AuthenticatedLayout><VendorsPage /></AuthenticatedLayout>}
        />
        <Route
          path="/vendors/add"
          element={<AuthenticatedLayout><AddVendorPage /></AuthenticatedLayout>}
        />
        <Route
          path="/services"
          element={<AuthenticatedLayout><ServicesPage /></AuthenticatedLayout>}
        />
        <Route
          path="/categories"
          element={<AuthenticatedLayout><CategoriesPage /></AuthenticatedLayout>}
        />
        <Route
          path="/packages"
          element={<AuthenticatedLayout><PackagesPage /></AuthenticatedLayout>}
        />
        <Route
          path="/categories/add"
          element={<AuthenticatedLayout><AddCategoryPage /></AuthenticatedLayout>}
        />
        <Route
          path="/bookings"
          element={<AuthenticatedLayout><BookingsPage /></AuthenticatedLayout>}
        />
        <Route path="/appointments" element={<Navigate to="/bookings" replace />} />
        <Route
          path="/transactions"
          element={<AuthenticatedLayout><TransactionsPage /></AuthenticatedLayout>}
        />
        <Route
          path="/withdraw-requests"
          element={<AuthenticatedLayout><WithdrawRequestPage /></AuthenticatedLayout>}
        />
        <Route
          path="/withdraw-requests/:id"
          element={<AuthenticatedLayout><WithdrawRequestDetailPage /></AuthenticatedLayout>}
        />
        <Route
          path="/vendor-bank-accounts"
          element={<AuthenticatedLayout><VendorBankAccountsPage /></AuthenticatedLayout>}
        />
        <Route
          path="/vendor-bank-accounts/user/:userId"
          element={<AuthenticatedLayout><VendorBankAccountDetailPage /></AuthenticatedLayout>}
        />
        <Route
          path="/vendor-bank-accounts/:id"
          element={<AuthenticatedLayout><VendorBankAccountDetailPage /></AuthenticatedLayout>}
        />
        <Route
          path="/"
          element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
